// eslint-disable-next-line
import Cookies from 'js-cookie';

const usePageLimit = () => {
  const n = 'per_page_limit';
  const set = (v) => Cookies.set(n, v);

  let l = Cookies.get(n);

  if (!l) {
    l = 16;
    set(l);
  }

  return {
    limit: l,
    set,
  };
};

export default usePageLimit;
